import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBelt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.375 8.25488H17.9019C17.4686 7.51152 16.6722 7.00605 15.75 7.00488H8.25C7.32781 7.00605 6.53135 7.51152 6.09805 8.25488H2.625C2.6248 8.25488 2.62454 8.25488 2.62429 8.25488C2.27934 8.25509 1.9998 8.53488 2 8.87988V15.1299C2 15.1301 2 15.1303 2 15.1306C2.0002 15.4755 2.28005 15.7551 2.625 15.7549H6.09805C6.53135 16.4982 7.32781 17.0037 8.25 17.0049H15.75C16.6722 17.0037 17.4686 16.4982 17.9019 15.7549H21.375C21.3753 15.7549 21.3755 15.7549 21.3757 15.7549C21.7207 15.7547 22.0002 15.4748 22 15.1299V8.87988C22 8.87962 22 8.87942 22 8.87917C21.9998 8.53422 21.72 8.25468 21.375 8.25488ZM3.25 14.5049V9.50488H5.75V14.5049H3.25ZM15.75 15.7549H8.25C7.55984 15.7544 7.00046 15.195 7 14.5049V12.6531H11.1663C11.5114 12.6531 11.7913 12.3733 11.7913 12.0281C11.7913 11.6829 11.5114 11.4031 11.1663 11.4031H7V9.50488C7.00046 8.81472 7.55984 8.25534 8.25 8.25488H15.75C16.4402 8.25534 16.9995 8.81472 17 9.50488V14.5049C16.9995 15.195 16.4402 15.7544 15.75 15.7549ZM20.75 14.5049H18.25V9.50488H20.75V14.5049Z",
		fill: "currentColor"
	})
});
export default SvgBelt;
